import {
  Grid,
  Typography,
  Dialog as MUIDialog,
  DialogContent,
  DialogActions,
  InputAdornment,
  IconButton,
  Box,
  TextField,
} from "@mui/material";
import { styled } from "styled-components";
import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Close, Edit } from "@mui/icons-material";
import { FaIdCard } from "react-icons/fa";

import { PrimaryButton } from "../../css components/Button";
import { useAxios } from "../../../hooks";
import { colors } from "../../css components/Style";
import { alert } from "../../../redux/slices/alertSlice";
import pages from "../../../constants/pages";

const ResendBtn = styled(PrimaryButton)`
  border: 2px solid #8f1c82;
  background: transparent;
  color: #8f1c82;
  &:hover {
    background: #f9e9f5;
  }
`;

const VerifyBtn = styled(PrimaryButton)`
  background: #28967e;
  color: white;
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }

  &:hover {
    background: #28967e;
  }
`;

const CircleIconBox = styled(Box)`
  width: 50px;
  height: 50px;
  background: #e5f7f4;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 10px;
`;

// const OTPTextField = styled.input`
//   width: 100%;
//   padding: 12px 16px;
//   border: 1px solid #ccc;
//   border-radius: 8px;
//   font-size: 16px;
//   outline: none;
// `;

const OTPTextField = styled(TextField)`
  width: 100%;

  .MuiOutlinedInput-root {
    border-radius: 8px;
    font-size: 16px;
    padding: 12px 16px;
    background-color: #fff;

    & fieldset {
      border: 1px solid #ccc;
    }

    &:hover fieldset {
      border-color: #999;
    }

    &.Mui-focused fieldset {
      border: 1px solid ${colors.green}; /* blue on focus */
    }

    & input {
      padding: 0; /* remove default MUI padding */
      font-size: 16px;
    }
  }
`;

export default function OtpVerification({
  agencyID,
  formikProps,
  verifyOTP,
  setVerifyOTP,
  brandID,
  setStep,
  setSignLoading,
  setEditState,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userID = sessionStorage.getItem("userID");

  const [loading, setLoading] = useState({
    resend: false,
    verify: false,
    send: false,
  });

  const [message, setMessage] = useState("");
  const [otpValue, setOtpValue] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [aadharNumber, setAadharNumber] = useState();

  function handleChange(e) {
    if (e.target.value?.toString().length > 6) {
      return;
    }
    setOtpValue(e.target.value);
  }

  const handleClose = () => {
    setLoading({
      resend: false,
      verify: false,
      send: false,
    });
    setAadharNumber();
    setVerifyOTP(false);
    setOtpSent(false);
  };

  function handleEnterAadharNumber(e) {
    if (e.target.value?.toString().length > 12) {
      return;
    }

    setAadharNumber(e.target.value);
  }

  return (
    <MUIDialog
      open={verifyOTP}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "16px",
            padding: "24px",
            minWidth: "420px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
          },
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Close />
      </IconButton>

      <DialogContent sx={{ px: 4, py: 3 }}>
        <CircleIconBox>
          <FaIdCard style={{ fontSize: "26", color: colors.green }} />
        </CircleIconBox>

        <Typography
          variant="h6"
          align="center"
          fontWeight={600}
          sx={{ color: "#28967e", mb: 8 }}
        >
          Verify Aadhaar
        </Typography>

        <OTPTextField
          size="small"
          placeholder="Enter Aadhaar Number"
          name="aadharNumber"
          // label="Aadhaar Number"
          value={aadharNumber}
          onChange={handleEnterAadharNumber}
          type="number"
          disabled={otpSent}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    style={{ padding: 0 }}
                    onClick={() => {
                      setOtpValue("");
                      setOtpSent(false);
                    }}
                    size="small"
                  >
                    <Edit sx={{ color: colors.info }} />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />

        <Typography variant="body2" align="center" sx={{ color: "#555", m: 4 }}>
          OTP will be sent to <strong>registered number.</strong>
        </Typography>

        {otpSent && (
          <>
            <OTPTextField
              formikProps={formikProps}
              type="number"
              onChange={handleChange}
              value={otpValue}
              name="otpValue"
              size="small"
              placeholder="Enter OTP"
            />

            {message && (
              <Typography
                sx={{ m: 4 }}
                variant="subtitle2"
                color={colors.error}
              >
                {message}
              </Typography>
            )}
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 4, pb: 3 }}>
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid size="auto" offset={{ md: "auto" }} />
          {otpSent ? (
            <Grid size sx={{ display: "flex", gap: 3 }}>
              <ResendBtn disabled={loading.resend} onClick={resendOTP}>
                {loading.resend ? "Resending..." : "Resend OTP"}
              </ResendBtn>

              <VerifyBtn
                disabled={otpValue.length < 6 || loading.verify}
                // loading={loading.verify}
                variant="contained"
                color="primary"
                autoFocus
                onClick={verificationOTP}
              >
                {loading.verify ? "Verifying..." : "Verify OTP"}
              </VerifyBtn>
            </Grid>
          ) : (
            <Grid size>
              <VerifyBtn
                disabled={
                  aadharNumber?.toString().length < 12 ||
                  !aadharNumber ||
                  loading.send
                }
                // loading={loading.send}
                variant="contained"
                color="primary"
                autoFocus
                onClick={handleSendOtp}
              >
                {loading.send ? "Sending..." : "Send OTP"}
              </VerifyBtn>
            </Grid>
          )}
        </Grid>
      </DialogActions>
    </MUIDialog>
  );

  function handleSendOtp() {
    setOtpSent(true);
    setLoading({ ...loading, send: true });

    axios({
      url: "/send/aadhar/otp",
      method: "POST",
      disableRedirect: true,
      data: {
        aadhar_number: parseInt(aadharNumber),
        user_id: parseInt(userID),
        msg_type: "agreement",
        brand_id: parseInt(brandID),
      },
    }).then((response) => {
      if (response.status) {
        setMessage(response.data.message);
        if (response?.data?.code === "000") {
          dispatch(
            alert({
              type: "success",
              message: response.data.message,
            })
          );
        }

        //If OTP is generated immediately for the second time ,
        //after the first successful generation

        if (response?.data?.code === "422028") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        if (response?.data?.code === "422005") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //IF WRONG AADHAAR NO IS ENTERED

        if (response?.data?.code === "422007") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //IF AADHAAR NO IS NOT LINKED WITH MOBILE NO

        if (response?.data?.code === "422008") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //HASH MISMATCH
        if (response?.data?.code === "470028") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //HASH PARAMETER NOT PROVIDED
        if (response?.data?.code === "470053") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //AADHAAR PARAMETER NOT PROVIDEd
        if (response?.data?.code === "470050") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //FLUCTUATIONS AT UIDAI SIDE
        if (response?.data?.code === "471007") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //fetching xml from uiadi end
        if (response?.data?.code === "333") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //CLIENT PARAMETER NOT PROVIDED MEAN
        if (response?.data?.code === "470046") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }
        setLoading({ ...loading, resend: false });
        setOtpSent(true);
      }
    });
  }

  function verificationOTP() {
    setLoading({ ...loading, verify: true });
    axios({
      url: "/verify/aadhar/otp",
      method: "POST",
      disableRedirect: true,
      data: {
        aadhar_number: parseInt(aadharNumber),
        user_id: parseInt(userID),
        msg_type: "agreement",
        brand_id: parseInt(brandID),
        otp: parseInt(otpValue),
      },
    }).then((response) => {
      if (response.status) {
        setMessage(response.data.message);

        if (response?.data?.code === "000") {
          formikProps.setValues((prev) => ({
            ...prev,
            verifyNumber: true,
            otp: "",
          }));
          setSignLoading({ 1: true });
          axios({
            url: "/sign/company/agreement?type=COMPANY_REGISTRATION",
            method: "POST",
            data: {
              company_id: formikProps.values?.ID,
              type: "COMPANY_REGISTRATION",
              signed: true,
            },
          }).then((response) => {
            if (response.status) {
              setStep(2);
              setEditState(false);
              formikProps.setValues((prev) => ({
                ...prev,
                viewAgreement: response.data,
                signAgreement: response.data.signed_agreement_link
                  ? true
                  : false,
              }));

              dispatch(
                alert({
                  type: "success",
                  message: "Agreement was successfully signed",
                })
              );
              if (brandID) {
                navigate(pages.createWelcomePage.route);
              }

              if (agencyID) {
                navigate(pages.welcomeAsAgencyPage.route);
              }

              setSignLoading({ 1: false });
            }
          });

          dispatch(
            alert({
              type: "success",
              message: "Aadhaar Verified Successfully",
            })
          );
          setVerifyOTP(false);
        }

        //IF WRONG OTP IS ENTERED
        if (response.data?.code === "422002") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //If wrong OTP is entered for the fourth time
        if (response.data?.code === "422004") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //TXN ALREADY COMPLETED- After successful XML fetch, if the same UUID is used , the same / different OTP is used.
        if (response.data?.code === "470048") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //If wrong UUID is passed
        if (response.data?.code === "470081") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }
        if (response.data?.code === "333") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }
      }

      setLoading({ ...loading, verify: false });
    });
  }

  function resendOTP() {
    setLoading({ ...loading, resend: true });

    axios({
      url: "/send/aadhar/otp",
      method: "POST",
      disableRedirect: true,
      data: {
        aadhar_number: parseInt(aadharNumber),
        user_id: parseInt(userID),
        msg_type: "agreement",
        brand_id: parseInt(brandID),
      },
    }).then((response) => {
      if (response.status) {
        if (response?.data?.code === "000") {
          dispatch(
            alert({
              type: "success",
              message: response.data.message,
            })
          );
        }

        //If OTP is generated immediately for the second time ,
        //after the first successful generation

        if (response?.data?.code === "422028") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        if (response?.data?.code === "422005") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //IF WRONG AADHAAR NO IS ENTERED

        if (response?.data?.code === "422007") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //IF AADHAAR NO IS NOT LINKED WITH MOBILE NO

        if (response?.data?.code === "422008") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //HASH MISMATCH
        if (response?.data?.code === "470028") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //HASH PARAMETER NOT PROVIDED
        if (response?.data?.code === "470053") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //AADHAAR PARAMETER NOT PROVIDEd
        if (response?.data?.code === "470050") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //FLUCTUATIONS AT UIDAI SIDE
        if (response?.data?.code === "471007") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //fetching xml from uiadi end
        if (response?.data?.code === "333") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //CLIENT PARAMETER NOT PROVIDED MEAN
        if (response?.data?.code === "470046") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }
        setLoading({ ...loading, resend: false });

        setOtpSent(true);
      }
    });
  }
}
